import type { AxiosResponse } from "axios";

import type { CancelableAxiosPromise, S3PutSuccess } from "./base";
import { baseService } from "./base";

export type EditLatestVersionPayload = {
  type: string;
  version: string;
};

let latestVersionsPromise: CancelableAxiosPromise | null = null;

export const playerReleaseService = {
  getReleaseHistory(): CancelableAxiosPromise {
    return baseService.get("/api/player/releases/history");
  },

  getLatestVersions(): CancelableAxiosPromise {
    if (!latestVersionsPromise) {
      latestVersionsPromise = baseService
        .get("/download/latest/json")
        .catch((error) => {
          latestVersionsPromise = null;
          throw error;
        }) as CancelableAxiosPromise;
    }

    return latestVersionsPromise;
  },

  loadAllVersions(): CancelableAxiosPromise {
    return baseService.get("/api/player/releases/versions");
  },

  editLatestVersions(
    serviceArgs: EditLatestVersionPayload[],
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put("/api/player/releases/versions", {
      versions: serviceArgs,
    });
  },

  getDeviceVersionStats(): CancelableAxiosPromise {
    return baseService.get("/api/player/releases/device_version_stats");
  },
};

export default playerReleaseService;
